import AvramGO from '../assets/images/avramgo.png';
import Spoty from '../assets/images/spoty.png';
import Shopboat from '../assets/images/shopboat.png';
import Slack from '../assets/images/slack.png';
import Envato from '../assets/images/envato.png';
import Jequery from '../assets/images/jquery.png';
import Woocommerce from '../assets/images/woocommerce.png';
import Themeforest from '../assets/images/themeforest.png';

const partnerInfo = [
  { logo: AvramGO, link: "https://avramgo.com" },
  { logo: Spoty, link: "https://spotify.com" },
  { logo: Shopboat, link: "https://shopboat.com" },
  { logo: Slack, link: "https://slack.com" },
  { logo: Envato, link: "https://envato.com" },
  { logo: Jequery, link: "https://jquery.com" },
  { logo: Woocommerce, link: "https://woocommerce.com" },
  { logo: Themeforest, link: "https://themeforest.net" },
];

export default partnerInfo;
